export default __webpack_public_path__ + "static/media/uiollyLogo@4x.3a239557.png";